import { CardContent, Grid } from '@mui/material';
import { dateTimeFormat } from 'utils/formatDate';
import { useStoreSelector } from 'v3/data/store';
import { OnlineContractingStateMapping } from 'v3/data/store/onlineContracting/mapping';
import { IHistory } from 'v3/services/online/interfaces/response';
import { BodySmallBold } from 'v3/shared/typography/BodySmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { BodySmallRegularStyled, CardHeaderStyled, CardStyled, Content } from '../styles';

export const OnlineHistoryInformation = () => {
  const {
    paymentDetails: { history },
  } = useStoreSelector((store) => store.onlineContracting);

  const getStatusMapped = (status: string) => OnlineContractingStateMapping[status]?.title ?? status;

  return (
    <CardStyled>
      <CardHeaderStyled
        title={
          <Content>
            <SubtitleLarge>Histórico</SubtitleLarge>
          </Content>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          {history.map((data: IHistory) => (
            <Grid size={{ xs: 6, sm: 4, md: 4, lg: 3 }}>
              <BodySmallRegularStyled>{getStatusMapped(data.status)}</BodySmallRegularStyled>
              <BodySmallBold className="empty-line">{dateTimeFormat(data.date)}</BodySmallBold>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </CardStyled>
  );
};
